import { useEffect, useRef, type RefObject } from 'react';

interface UseResizeObserverParams {
  target: RefObject<Element | null> | null;
  onResize: () => void;
  enabled?: boolean;
}

export function useResizeObserver({ target, onResize, enabled = true }: UseResizeObserverParams) {
  const onResizeRef = useRef(onResize);
  onResizeRef.current = onResize;

  useEffect(() => {
    const element = enabled ? target?.current : null;
    if (!element) return;

    let frame = 0;

    const handleResize = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => onResizeRef.current());
    };

    const observer = new ResizeObserver(handleResize);
    observer.observe(element);

    return () => {
      cancelAnimationFrame(frame);
      observer.disconnect();
    };
  }, [target, enabled]);
}
